import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SEOHead from '@/components/base/SEOHead';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategorySection from './components/CategorySection';
import ValueProposition from './components/ValueProposition';
import ArticlesSection from './components/ArticlesSection';
import TestimonialSection from './components/TestimonialSection';
import CTASection from './components/CTASection';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://hipobuyspreadsheets.lol';

const homeJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'WebSite',
      '@id': `${SITE_URL}/#website`,
      name: 'Hipobuy Spreadsheet',
      url: SITE_URL,
      description: 'Guide complet du hipobuy spreadsheet : tutoriels, comparatifs, astuces avancées et analyses détaillées pour maîtriser l\'organisation de vos données.',
      inLanguage: 'fr',
      potentialAction: {
        '@type': 'SearchAction',
        target: {
          '@type': 'EntryPoint',
          urlTemplate: `${SITE_URL}/search?q={search_term_string}`,
        },
        'query-input': 'required name=search_term_string',
      },
    },
    {
      '@type': 'Organization',
      '@id': `${SITE_URL}/#organization`,
      name: 'Hipobuy Spreadsheet',
      url: SITE_URL,
      sameAs: [
        'https://kaspreadsheet.com',
      ],
    },
  ],
};

export default function Home() {
  return (
    <main className="min-h-screen bg-background-50">
      <JsonLd schema={homeJsonLd} />
      <SEOHead
        title="Hipobuy Spreadsheet — Guide Complet, Comparaisons et Tutoriels 2026"
        description="Découvrez le guide ultime du hipobuy spreadsheet : tutoriels, comparatifs, astuces avancées et analyses détaillées pour maîtriser l'organisation de vos données. Mis à jour pour 2026 avec plus de 10 articles SEO optimisés."
        keywords="hipobuy spreadsheet, guide hipobuy spreadsheet, comparatif spreadsheet, tutoriel hipobuy, meilleur spreadsheet 2026"
        canonical={`${SITE_URL}/`}
      />
      <Navbar />
      <HeroSection />
      <CategorySection />
      <ValueProposition />
      <ArticlesSection />
      <TestimonialSection />
      <CTASection />
      <Footer />
    </main>
  );
}